import { render, staticRenderFns } from "./renewalRatio.vue?vue&type=template&id=b61bced6&scoped=true&"
import script from "./renewalRatio.vue?vue&type=script&lang=js&"
export * from "./renewalRatio.vue?vue&type=script&lang=js&"
import style0 from "./renewalRatio.vue?vue&type=style&index=0&id=b61bced6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61bced6",
  null
  
)

export default component.exports